module.exports = __webpack_public_path__ + "img/50.9cf78c1f.jpg";